/**
 * @file automatically generated from MApp.Endpoints.CopyrightContentController
 */ 

import { MetadataClient } from '../metadataClient';
import { ISaveCopyright, ICopyright, ICopyrightListItem, ICopyrightDataset, IValidationResult } from '../models';

export class CopyrightContentClient extends MetadataClient {

    public static saveCopyright(copyright: ISaveCopyright) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/copyrights`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(copyright)
			})
        );
    }

    public static updateCopyright(id: string, copyright: ISaveCopyright) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/copyrights/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(copyright)
			})
        );
    }

    public static getCopyright(id: string) {
        return MetadataClient.ajax<ICopyright>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/copyrights/${encodeURIComponent(id)}`)
        );
    }

    public static getCopyrights() {
        return MetadataClient.ajax<ICopyrightListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/copyrights`)
        );
    }

    public static deleteCopyright(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/copyrights/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static getDatasets() {
        return MetadataClient.ajax<ICopyrightDataset[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/copyrights/datasets`)
        );
    }

    public static isValidCopyright(name: string) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/copyrights/isvalid?name=${encodeURIComponent(name)}`)
        );
    }
}
